// eslint-disable-next-line max-len
const VALID_EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * @param {string} email
 */
const validEmail = (email) => VALID_EMAIL_REGEX.test(String(email).toLowerCase());

// eslint-disable-next-line import/no-default-export
export default validEmail;
